import AitiCoreUtils from './core/utils';
import AitiCoreWebsite from './core/website';
import AitiCoreStore from './core/store';
import AitiCoreCustomer from './core/customer';
import AitiCoreCookies from './core/cookies';
import AitiCoreClients from './core/clients';
import AitiCoreValidators from './core/validators';
import AitiCoreTranslator from './core/translator';

export default class AitiCore {

    private readonly _utils: AitiCoreUtils;
    private readonly _website: AitiCoreWebsite;
    private readonly _store: AitiCoreStore;
    private readonly _customer: AitiCoreCustomer;
    private readonly _cookies: AitiCoreCookies;
    private readonly _clients: AitiCoreClients;
    private readonly _validators: AitiCoreValidators;
    private readonly _translator: AitiCoreTranslator;

    constructor() {
        this._utils = new AitiCoreUtils();
        this._website = new AitiCoreWebsite();
        this._store = new AitiCoreStore();
        this._customer = new AitiCoreCustomer();
        this._cookies = new AitiCoreCookies();
        this._clients = new AitiCoreClients();
        this._validators = new AitiCoreValidators();
        this._translator = new AitiCoreTranslator();
    }

    getUtils() {
        return this._utils;
    }

    getWebsite() {
        return this._website;
    }

    getStore() {
        return this._store;
    }

    getCustomer() {
        return this._customer;
    }

    getCookies() {
        return this._cookies;
    }

    getClients() {
        return this._clients;
    }

    getValidators() {
        return this._validators;
    }

    getTranslator() {
        return this._translator;
    }
}

declare global {
    const AitiCore: AitiCore;
}

/**
 * @type {AitiCore}
 */
global.AitiCore = new AitiCore();
